export enum ToastId {
  IdleAutoLogout = 'IdleAutoLogout',
  ExaminationAutoSaveError = 'ExaminationAutoSaveError',
}
